Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.FiltersView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters"]

  events:
    'click .removeAll': 'onRemoveAllFilters'
    'click a.toggle': 'toggle'
    'click #query-filters-tabs li': 'onFilterModeChange'
    'click #post-filters': 'onPostFilters'
    'click #content-filters': 'onContentFilters'

  onRemoveAllFilters: =>
    realTime = @searchQuery.get('date_from_realtime')
    from = @searchQuery.get('date_from')
    fromISO = @searchQuery.get('date_from_ISO')
    to = @searchQuery.get('date_to')
    toISO = @searchQuery.get('date_to_ISO')
    now = @searchQuery.get('date_now')

    postFrom = @searchQuery.get('post_from')
    postFromISO = @searchQuery.get('post_from_ISO')
    postTo = @searchQuery.get('post_to')
    postToISO = @searchQuery.get('post_to_ISO')
    postNow = @searchQuery.get('post_now')

    @searchQuery.reset()

    @searchQuery.set('date_from_realtime', realTime)
    @searchQuery.set('date_from', from)
    @searchQuery.set('date_from_ISO', fromISO)
    @searchQuery.set('date_to', to)
    @searchQuery.set('date_to_ISO', toISO)
    @searchQuery.set('date_now', now)

    @searchQuery.set('post_from', postFrom)
    @searchQuery.set('post_from_ISO', postFromISO)
    @searchQuery.set('post_to', postTo)
    @searchQuery.set('post_to_ISO', postToISO)
    @searchQuery.set('post_now', postNow)

    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @postFacets = @options.postFacets
    @customTexts = Keepcon.customTexts
    @topics = @options.topics || []
    @tagsByClientCode = @options.tagsByClientCode || []
    @filterCollection = []
    @appliedFilterCollection = []
    @dashboardSearchMethod = @options.searchMethod
    @isReplyFilter = @options.isReplyFilter
    @sortedAvailableChannelsByProvider = @options.sortedAvailableChannelsByProvider

  destroy: ->
    @appliedTopicsView.destroy()
    @appliedTagsView.destroy()
    @appliedLabelsView.destroy()
    @appliedLocationView.destroy()
    @appliedModeratorView.destroy()
    @appliedUserView.destroy()
    @appliedPageOwnerView.destroy()
    @appliedStatusView.destroy()
    @appliedRatingView.destroy()
    @appliedReviewStatusView.destroy()
    @appliedTypeView.destroy()
    @appliedHashtagView.destroy()
    @appliedMentionView.destroy()
    @appliedDateView.destroy()
    @appliedModerationDateView.destroy()
    @appliedSentimentView.destroy()
    @appliedCountryView.destroy()
    @appliedCustomFacetsView.destroy()
    @appliedCustomTextsView.destroy()
    @appliedSubtypeView.destroy()
    @appliedSocialNetworkIdView.destroy()
    @appliedFollowersCountView.destroy()
    @appliedGeolocationView.destroy()
    @appliedPostTypeView.destroy()
    @appliedKeywordsView.destroy()
    @appliedGenericUserView.destroy()
    @appliedFromPublishedFilter.destroy()
    @appliedCustomerTicketFilterView.destroy()
    @googleMyBusinessFilters.destroy()

    @keywordsFilterView.destroy()
    @tagsFilterView.destroy()
    @tagsFilterView.destroy()
    @labelsFilterView.destroy() if @labelsFilterView
    @locationFilterView.destroy()
    @appliedDiscoveredTopicsView.destroy()
    @moderatorFilterView.destroy()
    @userFilterView.destroy()
    @pageOwnerFilterView.destroy()
    @reviewStatusFilterView.destroy()
    @statusFilterView.destroy()
    @typeFilterView.destroy()
    @dateFilterView.destroy()
    @moderationDateFilterView.destroy()
    @sentimentFilterView.destroy()
    @countryFilterView.destroy()
    @customFacetsFilterView.destroy()
    @customTextsFilterView.destroy()
    @subtypeFilterView.destroy()
    @postTypeFilterView.destroy()
    @genericUserFilterView.destroy()
    @customerTicketFilterView.destroy()
    @fromPublishedFilterView.destroy()

    this.remove()
    return false

  render: ->
    @$el.html(@template(
      analysisMode: @searchQuery.get('analysisMode')
      searchingPosts: @dashboardSearchMethod == 'posts'
      postSelectionDone: @searchQuery.postSelectionDone()
      isReplyFilter: @isReplyFilter
    ))

    # This is to migrate the old keywords filter format to the new one.
    # This can be safely removed only when all sessions are using the new format.
    @migrateKeywordsFilterFormat()

    # This is to migrate the old tags filter in campaign mode to the new one.
    # This can be safely removed only when all sessions are using the new format.
    # All sessions created or modified in version 1.25 or higher are using the new format.
    @migratePostTagsFilterFormat()

    # This is to migrate the old labels filter to the new one.
    # This can be safely removed only when all sessions are using the new format.
    @migrateLabelsFilterFormat()

    @appliedTopicsView = new Monitoring.Views.SocialContents.Filters.AppliedTopicsView({ searchQuery: @searchQuery })
    @$el.find('#applied_topic').html(@appliedTopicsView.render().el)

    @appliedPosts = new Monitoring.Views.SocialContents.Filters.AppliedPostsView({ searchQuery: @searchQuery })
    @$el.find('#applied_posts').html(@appliedPosts.render().el)

    @appliedTagsNodeNameView = new Monitoring.Views.SocialContents.Filters.AppliedTagsNodeNameView({ searchQuery: @searchQuery })
    @$el.find('#applied_tags_node_name').html(@appliedTagsNodeNameView.render().el)

    @appliedOnlyTagsOfNodeName = new Monitoring.Views.SocialContents.Filters.AppliedOnlyTagsOfNodeName({ searchQuery: @searchQuery })
    @$el.find('#applied_only_tags_of_node_name').html(@appliedOnlyTagsOfNodeName.render().el)

    @appliedTagsView = new Monitoring.Views.SocialContents.Filters.AppliedTagsView({ searchQuery: @searchQuery, tagsByClientCode: @tagsByClientCode })
    @$el.find('#applied_general_tag').html(@appliedTagsView.render().el)

    @appliedGenderView = new Monitoring.Views.SocialContents.Filters.AppliedGenderView({ searchQuery: @searchQuery })
    @$el.find('#applied_gender').html(@appliedGenderView.render().el)

    @appliedLabelsView = new Monitoring.Views.SocialContents.Filters.AppliedLabelsView({ searchQuery: @searchQuery })
    @$el.find('#applied_label').html(@appliedLabelsView.render().el)

    @appliedLocationView = new Monitoring.Views.SocialContents.Filters.AppliedLocationView({ searchQuery: @searchQuery })
    @$el.find('#applied_location').html(@appliedLocationView.render().el)

    @appliedDiscoveredTopicsView = new Monitoring.Views.SocialContents.Filters.AppliedDiscoveredTopicsFilterView({ searchQuery: @searchQuery })
    @$el.find('#applied_discovered_topics').html(@appliedDiscoveredTopicsView.render().el)

    @appliedKeywordsView = new Monitoring.Views.SocialContents.Filters.AppliedKeywordsView({ searchQuery: @searchQuery })
    @$el.find('#applied_keyword').html(@appliedKeywordsView.render().el)

    @appliedModeratorView = new Monitoring.Views.SocialContents.Filters.AppliedModeratorView({ searchQuery: @searchQuery })
    @$el.find('#applied_moderator').html(@appliedModeratorView.render().el)

    @appliedUserView = new Monitoring.Views.SocialContents.Filters.AppliedUserView({ searchQuery: @searchQuery })
    @$el.find('#applied_user').html(@appliedUserView.render().el)

    @appliedPageOwnerView = new Monitoring.Views.SocialContents.Filters.AppliedPageOwnerView({ searchQuery: @searchQuery })
    @$el.find('#applied_page_owner').html(@appliedPageOwnerView.render().el)

    @appliedParentPostView = new Monitoring.Views.SocialContents.Filters.AppliedParentPostView({ searchQuery: @searchQuery })
    @$el.find('#applied_parent_post').html(@appliedParentPostView.render().el)

    @appliedStatusView = new Monitoring.Views.SocialContents.Filters.AppliedStatusView({ searchQuery: @searchQuery })
    @$el.find('#applied_status').html(@appliedStatusView.render().el)

    @appliedGmbCountriesView = new Monitoring.Views.SocialContents.Filters.AppliedGmbCountriesFilterView({searchQuery: @searchQuery})
    @$el.find('#applied_gmb_countries_filter').html(@appliedGmbCountriesView.render().el)

    @appliedGmbProvincesView = new Monitoring.Views.SocialContents.Filters.AppliedGmbProvincesFilterView({searchQuery: @searchQuery})
    @$el.find('#applied_gmb_provinces_filter').html(@appliedGmbProvincesView.render().el)

    @appliedGmbCitiesView = new Monitoring.Views.SocialContents.Filters.AppliedGmbCitiesFilterView({searchQuery: @searchQuery})
    @$el.find('#applied_gmb_cities_filter').html(@appliedGmbCitiesView.render().el)

    @appliedGmbAddressesView = new Monitoring.Views.SocialContents.Filters.AppliedGmbAddressesFilterView({searchQuery: @searchQuery})
    @$el.find('#applied_gmb_addresses_filter').html(@appliedGmbAddressesView.render().el)

    @appliedRatingView = new Monitoring.Views.SocialContents.Filters.AppliedRatingView({searchQuery: @searchQuery})
    @$el.find('#applied_rating_filter').html(@appliedRatingView.render().el)

    appliedReviewStatusClass = if @searchQuery.get('reviewMode')
      Monitoring.Views.SocialContents.Filters.ReviewModeAppliedReviewStatusView
    else
      Monitoring.Views.SocialContents.Filters.AppliedReviewStatusView
    @appliedReviewStatusView = new appliedReviewStatusClass({ searchQuery: @searchQuery })
    @$el.find('#applied_review_status').html(@appliedReviewStatusView.render().el)

    @appliedTypeView = new Monitoring.Views.SocialContents.Filters.AppliedTypeView({ searchQuery: @searchQuery })
    @$el.find('#applied_type').html(@appliedTypeView.render().el)

    @appliedHashtagView = new Monitoring.Views.SocialContents.Filters.AppliedHashtagView({ searchQuery: @searchQuery })
    @$el.find('#applied_hashtag').html(@appliedHashtagView.render().el)

    @appliedMentionView = new Monitoring.Views.SocialContents.Filters.AppliedMentionView({ searchQuery: @searchQuery })
    @$el.find('#applied_mention').html(@appliedMentionView.render().el)

    @appliedDateView = new Monitoring.Views.SocialContents.Filters.AppliedDateView({ searchQuery: @searchQuery })
    @$el.find('#applied_date').html(@appliedDateView.render().el)

    @appliedModerationDateView = new Monitoring.Views.SocialContents.Filters.AppliedModerationDateView({ searchQuery: @searchQuery })
    @$el.find('#applied_moderation_date').html(@appliedModerationDateView.render().el)

    @appliedLanguageView = new Monitoring.Views.SocialContents.Filters.AppliedLanguageView({ searchQuery: @searchQuery })
    @$el.find('#applied_language').html(@appliedLanguageView.render().el)

    @appliedSentimentView = new Monitoring.Views.SocialContents.Filters.AppliedSentimentView({ searchQuery: @searchQuery })
    @$el.find('#applied_sentiment').html(@appliedSentimentView.render().el)

    @appliedCountryView = new Monitoring.Views.SocialContents.Filters.AppliedCountryView({ searchQuery: @searchQuery })
    @$el.find('#applied_country').html(@appliedCountryView.render().el)

    @appliedCustomFacetsView = new Monitoring.Views.SocialContents.Filters.AppliedCustomFacetsView({ searchQuery: @searchQuery })
    @$el.find('#applied_custom_facets').html(@appliedCustomFacetsView.render().el)

    @appliedCustomTextsView = new Monitoring.Views.SocialContents.Filters.AppliedCustomTextsView({ searchQuery: @searchQuery })
    @$el.find('#applied_custom_texts').html(@appliedCustomTextsView.render().el)

    @appliedSubtypeView = new Monitoring.Views.SocialContents.Filters.AppliedSubtypeView({ searchQuery: @searchQuery })
    @$el.find('#applied_subtype').html(@appliedSubtypeView.render().el)

    @appliedSocialNetworkIdView = new Monitoring.Views.SocialContents.Filters.AppliedSocialNetworkIdView({ searchQuery: @searchQuery })
    @$el.find('#applied_social_network_id').html(@appliedSocialNetworkIdView.render().el)

    @appliedFollowersCountView = new Monitoring.Views.SocialContents.Filters.AppliedFollowersCountView({ searchQuery: @searchQuery })
    @$el.find('#applied_followers_count').html(@appliedFollowersCountView.render().el)

    @appliedGeolocationView = new Monitoring.Views.SocialContents.Filters.AppliedGeolocationView({ searchQuery: @searchQuery })
    @$el.find('#applied_geolocation').html(@appliedGeolocationView.render().el)

    @appliedPostTypeView = new Monitoring.Views.SocialContents.Filters.AppliedPostTypeView({ searchQuery: @searchQuery })
    @$el.find('#applied_post_type').html(@appliedPostTypeView.render().el)

    @appliedFacebookPublishedFilter = new Monitoring.Views.SocialContents.Filters.AppliedPublishedFilterView({ searchQuery: @searchQuery })
    @$el.find('#applied_facebook_published_filter').html(@appliedFacebookPublishedFilter.render().el)

    @appliedInstagramPromotedFilter = new Monitoring.Views.SocialContents.Filters.AppliedInstagramPromotedFilterView({ searchQuery: @searchQuery })
    @$el.find('#applied_instagram_promoted_filter').html(@appliedInstagramPromotedFilter.render().el)

    @appliedFromPublishedFilter = new Monitoring.Views.SocialContents.Filters.AppliedFromPublishedView({ searchQuery: @searchQuery })
    @$el.find('#applied_facebook_is_from_published_filter').html(@appliedFromPublishedFilter.render().el)

    @appliedCustomerTicketFilterView = new Monitoring.Views.SocialContents.Filters.AppliedCustomerTicketFilterView({ searchQuery: @searchQuery })
    @$el.find('#applied_customer_ticket_filter').html(@appliedCustomerTicketFilterView.render().el)

    @appliedGenericUserView = new Monitoring.Views.SocialContents.Filters.AppliedGenericUserView({ searchQuery: @searchQuery })
    @$el.find('#applied_generic_user').html(@appliedGenericUserView.render().el)

    @facebookPublishedFilter = new Monitoring.Views.SocialContents.Filters.FacebookPublishedFilterView({searchQuery: @searchQuery, facet: @facets})
    @$el.find('#facebook_published_filter').html(@facebookPublishedFilter.render().el)

    @instagramPromotedFilter = new Monitoring.Views.SocialContents.Filters.InstagramPromotedFilterView({searchQuery: @searchQuery, facet: @facets})
    @$el.find('#instagram_promoted_filter').html(@instagramPromotedFilter.render().el)

    @fromPublishedFilterView = new Monitoring.Views.SocialContents.Filters.FromPublishedFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#facebook_is_from_published_filter').html(@fromPublishedFilterView.render().el)

    @customerTicketFilterView = new Monitoring.Views.SocialContents.Filters.CustomerTicketFilterView({ searchQuery: @searchQuery })
    @$el.find('#customer_ticket_filter').html(@customerTicketFilterView.render().el)

    @tagsFilterView = new Monitoring.Views.SocialContents.Filters.TagsFilterView({ searchQuery: @searchQuery, facet: @facets, tagsByClientCode: @tagsByClientCode })
    @$el.find('#general_tag_filter').html(@tagsFilterView.render().el)

    @keywordsFilterView = new Monitoring.Views.SocialContents.Filters.KeywordsFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#keyword_filter').html(@keywordsFilterView.render().el)

    @genderFilterView = new Monitoring.Views.SocialContents.Filters.GenderFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#gender_filter').html(@genderFilterView.render().el)

    @labelsFilterView = new Monitoring.Views.SocialContents.Filters.LabelsFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#label_filter').html(@labelsFilterView.render().el)

    @locationFilterView = new Monitoring.Views.SocialContents.Filters.LocationFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#location_filter').html(@locationFilterView.render().el)

    @moderatorFilterView = new Monitoring.Views.SocialContents.Filters.ModeratorFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#moderator_filter').html(@moderatorFilterView.render().el)

    @userFilterView = new Monitoring.Views.SocialContents.Filters.UserFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#user_filter').html(@userFilterView.render().el)

    @pageOwnerFilterView = new Monitoring.Views.SocialContents.Filters.PageOwnerFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#page_owner_filter').html(@pageOwnerFilterView.render().el)

    @statusFilterView = new Monitoring.Views.SocialContents.Filters.StatusFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#status_filter').html(@statusFilterView.render().el)

    @followersCountFilterView = new Monitoring.Views.SocialContents.Filters.FollowersCountFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#followers_count_filter').html(@followersCountFilterView.render().el)

    @genericUserFilterView = new Monitoring.Views.SocialContents.Filters.GenericUserFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#generic_user_filter').html(@genericUserFilterView.render().el)

    reviewStatusClass = if @searchQuery.get('reviewMode')
        Monitoring.Views.SocialContents.Filters.ReviewModeReviewStatusFilterView
      else
        Monitoring.Views.SocialContents.Filters.ReviewStatusFilterView
    @reviewStatusFilterView = new reviewStatusClass({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#review_status_filter').html(@reviewStatusFilterView.render().el)

    @typeFilterView = new Monitoring.Views.SocialContents.Filters.TypeFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#type_filter').html(@typeFilterView.render().el)

    filters_container = @$el.find('#filters-container')
    @dateFilterView = new Monitoring.Views.SocialContents.Filters.DateFilterView({ searchQuery: @searchQuery, facet: @facets, filtersContainer: filters_container })
    @$el.find('#date_filter').html(@dateFilterView.render().el)

    @moderationDateFilterView = new Monitoring.Views.SocialContents.Filters.ModerationDateFilterView({ searchQuery: @searchQuery, facet: @facets, filtersContainer: filters_container })
    @$el.find('#moderation_date_filter').html(@moderationDateFilterView.render().el)

    @languageFilterView = new Monitoring.Views.SocialContents.Filters.LanguageFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#language_filter').html(@languageFilterView.render().el)

    @sentimentFilterView = new Monitoring.Views.SocialContents.Filters.SentimentFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#sentiment_filter').html(@sentimentFilterView.render().el)

    @countryFilterView = new Monitoring.Views.SocialContents.Filters.CountryFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#country_filter').html(@countryFilterView.render().el)

    @customFacetsFilterView = new Monitoring.Views.SocialContents.Filters.CustomFacetsFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#custom_facets_filter').html(@customFacetsFilterView.render().el)

    @customTextsFilterView = new Monitoring.Views.SocialContents.Filters.CustomTextsFilterView({ searchQuery: @searchQuery, facet: @facets, customTexts: @customTexts })
    @$el.find('#custom_text_filter').html(@customTextsFilterView.render().el)

    @subtypeFilterView = new Monitoring.Views.SocialContents.Filters.SubtypeFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#subtype_filter').html(@subtypeFilterView.render().el)

    @postTypeFilterView = new Monitoring.Views.SocialContents.Filters.PostTypeFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#post_type_filter').html(@postTypeFilterView.render().el)

    @googleMyBusinessFilters = new Monitoring.Views.SocialContents.Filters.GoogleMyBusinessFilters({
      searchQuery: @searchQuery
    })
    @$el.find('#google_my_business_filters').html(@googleMyBusinessFilters.render().el)

    if @isReplyFilter
      @twitterReplyFilterView = new Monitoring.Views.SocialContents.Filters.ReplyFilterView({searchQuery: @searchQuery, source: 'twitter', type: 'twitter'})
      @$el.find('#twitter_reply_filter').html(@twitterReplyFilterView.render().el)

      @facebookReplyFilterView = new Monitoring.Views.SocialContents.Filters.ReplyFilterView({searchQuery: @searchQuery, source: 'facebook', type: 'facebook'})
      @$el.find('#facebook_reply_filter').html(@facebookReplyFilterView.render().el)

      @appliedTwitterReplyFilterView = new Monitoring.Views.SocialContents.Filters.AppliedReplyFilterView({searchQuery: @searchQuery, source: 'twitter'})
      @$el.find('#applied_twitter_reply_filter').html(@appliedTwitterReplyFilterView.render().el)

      @appliedFacebookReplyFilterView = new Monitoring.Views.SocialContents.Filters.AppliedReplyFilterView({searchQuery: @searchQuery, source: 'facebook'})
      @$el.find('#applied_facebook_reply_filter').html(@appliedFacebookReplyFilterView.render().el)

    if @searchQuery.get('analysisMode')

      @appliedPostDateView = new Monitoring.Views.SocialContents.Filters.AppliedPostDateView({ searchQuery: @searchQuery })
      @$el.find('#applied_post_date').html(@appliedPostDateView.render().el)

      @appliedPostKeywordView = new Monitoring.Views.SocialContents.Filters.AppliedPostKeywordView({ searchQuery: @searchQuery })
      @$el.find('#applied_post_keyword').html(@appliedPostKeywordView.render().el)

      @appliedPostHashtagView = new Monitoring.Views.SocialContents.Filters.AppliedPostHashtagView({ searchQuery: @searchQuery })
      @$el.find('#applied_post_hashtag').html(@appliedPostHashtagView.render().el)

      @appliedPostMentionView = new Monitoring.Views.SocialContents.Filters.AppliedPostMentionView({ searchQuery: @searchQuery })
      @$el.find('#applied_post_mention').html(@appliedPostMentionView.render().el)

      @appliedPostTagsView = new Monitoring.Views.SocialContents.Filters.AppliedPostTagsView({ searchQuery: @searchQuery, tagsByClientCode: @tagsByClientCode })
      @$el.find('#applied_post_tag').html(@appliedPostTagsView.render().el)

      @appliedPostLabelsView = new Monitoring.Views.SocialContents.Filters.AppliedPostLabelsView({ searchQuery: @searchQuery })
      @$el.find('#applied_post_label').html(@appliedPostLabelsView.render().el)

      @appliedPostChannelView = new Monitoring.Views.SocialContents.Filters.AppliedPostChannelsView({ searchQuery: @searchQuery})
      @$el.find('#applied_post_channel').html(@appliedPostChannelView.render().el)

      @appliedPostFacebookTypeFilterView = new Monitoring.Views.SocialContents.Filters.AppliedPostFacebookTypeFilterView({ searchQuery: @searchQuery, facet: @facets })
      @$el.find('#applied_post_facebook_type').html(@appliedPostFacebookTypeFilterView.render().el)

      @appliedPostPublishedFilterView = new Monitoring.Views.SocialContents.Filters.AppliedPostPublishedFilterView({ searchQuery: @searchQuery })
      @$el.find('#applied_post_published').html(@appliedPostPublishedFilterView.render().el)

      @appliedPostInstagramPromotedFilter = new Monitoring.Views.SocialContents.Filters.AppliedInstagramPromotedFilterView({ searchQuery: @searchQuery })
      @$el.find('#applied_post_instagram_promoted_filter').html(@appliedPostInstagramPromotedFilter.render().el)

      @appliedPostSourceView = new Monitoring.Views.SocialContents.Filters.AppliedPostSourceView({ searchQuery: @searchQuery })
      @$el.find('#applied_post_source').html(@appliedPostSourceView.render().el)

      @appliedPostSourceTypeView = new Monitoring.Views.SocialContents.Filters.AppliedPostSourceTypeView({ searchQuery: @searchQuery })
      @$el.find('#applied_post_source_type').html(@appliedPostSourceTypeView.render().el)

      @postDateFilterView = new Monitoring.Views.SocialContents.Filters.PostDateFilterView({ searchQuery: @searchQuery, facet: @facets, filtersContainer: filters_container })
      @$el.find('#post_date_filter').html(@postDateFilterView.render().el)

      @postTagsFilterView = new Monitoring.Views.SocialContents.Filters.PostTagsFilterView({ searchQuery: @searchQuery, facet: @postFacets, tagsByClientCode: @tagsByClientCode })
      @$el.find('#post_tag_filter').html(@postTagsFilterView.render().el)

      @postLabelsFilterView = new Monitoring.Views.SocialContents.Filters.PostLabelsFilterView({ searchQuery: @searchQuery, facet: @postFacets })
      @$el.find('#post_label_filter').html(@postLabelsFilterView.render().el)

      @postSourceFilterView = new Monitoring.Views.SocialContents.Filters.PostSourceFilterView({ searchQuery: @searchQuery, facet: @postFacets })
      @$el.find('#post_source_filter').html(@postSourceFilterView.render().el)

      @postSourceTypeFilterView = new Monitoring.Views.SocialContents.Filters.PostSourceTypeFilterView({ searchQuery: @searchQuery, facet: @postFacets })
      @$el.find('#post_source_type_filter').html(@postSourceTypeFilterView.render().el)

      @postChannelFilterView = new Monitoring.Views.SocialContents.Filters.PostChannelFilterView({
        searchQuery: @searchQuery
        sortedAvailableChannelsByProvider: @sortedAvailableChannelsByProvider
      })
      @$el.find('#post_channel_filter').html(@postChannelFilterView.render().el)

      @postKeywordFilterView = new Monitoring.Views.SocialContents.Filters.PostKeywordFilterView({ searchQuery: @searchQuery, facet: @facets })
      @$el.find('#post_keyword_filter').html(@postKeywordFilterView.render().el)

      @postFacebookTypeFilterView = new Monitoring.Views.SocialContents.Filters.PostFacebookTypeFilterView({ searchQuery: @searchQuery, facet: @facets })
      @$el.find('#post_facebook_type').html(@postFacebookTypeFilterView.render().el)

      @postPublishedFilterView = new Monitoring.Views.SocialContents.Filters.PostPublishedFilterView({ searchQuery: @searchQuery, facet: @facets })
      @$el.find('#post_published').html(@postPublishedFilterView.render().el)

      @postInstagramFilterView = new Monitoring.Views.SocialContents.Filters.InstagramPromotedFilterView({ searchQuery: @searchQuery, facet: @facets })
      @$el.find('#post_instagram_promoted_filter').html(@postInstagramFilterView.render().el)

      if @isReplyFilter
        @twitterPostReplyFilterView = new Monitoring.Views.SocialContents.Filters.PostReplyFilterView({searchQuery: @searchQuery, source: 'twitter', type: 'twitter'})
        @$el.find('#twitter_post_reply_filter').html(@twitterPostReplyFilterView.render().el)

        @appliedTwitterPostReplyFilterView = new Monitoring.Views.SocialContents.Filters.AppliedPostReplyFilterView({searchQuery: @searchQuery, source: 'twitter'})
        @$el.find('#applied_post_twitter_reply').html(@appliedTwitterPostReplyFilterView.render().el)

    inMyHistorySession = $('li.active a span #name').text() == 'My History'
    if inMyHistorySession
      # circumvent the hiding of filters for moderators in My History session
      @$el.find('.add-filters').attr('style', 'display:block !important')
      # remove actions menu and text/charts buttons in My History session
      $('.view-selection').remove()

    return this

  migrateKeywordsFilterFormat: ->
    mustUpdate = false
    if (@searchQuery.get('texts').length > 0) and @searchQueryIsOld()
      mustUpdate = true
      betterSection = if @searchQuery.get('texts_logic') == 'OR' then 'primary' else 'secondary'
      @searchQuery.set("#{betterSection}_keywords", _.union(@searchQuery.get('texts'), @searchQuery.get("#{betterSection}_keywords")))
      @searchQuery.set("#{betterSection}_keywords_logic", @searchQuery.get('texts_logic'))
      @searchQuery.set('texts', [])
    if @searchQuery.get('text_exclusions').length > 0 and @searchQueryIsOld()
      mustUpdate = true
      @searchQuery.set('excluded_keywords', _.union(@searchQuery.get('text_exclusions'), @searchQuery.get('excluded_keywords')))
      @searchQuery.set('excluded_keywords_logic', @searchQuery.get('texts_logic'))
      @searchQuery.set('text_exclusions', [])
    if mustUpdate
      console.log("Triggered event to update query")
      @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  searchQueryIsOld: ->
    _.every(_.each(['primary', 'secondary', 'excluded'], (section) =>
      @searchQuery.get("#{section}_keywords").length == 0
    ))

  migratePostTagsFilterFormat: ->
    if (@searchQuery.get('post_tags').length > 0)
      @searchQuery.set("post_primary_tags", _.union(@searchQuery.get('post_tags'), @searchQuery.get("post_primary_tags")))
      @searchQuery.set('post_tags', [])
      console.log("Triggered event to update query")
      @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  migrateLabelsFilterFormat: ->
    if (@searchQuery.get('labels').length > 0)
      @searchQuery.set("primary_labels", _.union(@searchQuery.get('labels'), @searchQuery.get("primary_labels")))
      @searchQuery.set('labels', [])
      console.log("Triggered event to update query")
      @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  toggle: (event) =>
    @constructor.toggleFilter $(event.currentTarget).closest('.filter')

  @toggleFilter: (filter) ->
    icon = filter.find('i:not(".fa")')
    filter.toggleClass 'collapsed expanded'
    icon.toggleClass 'icon-chevron-down icon-chevron-right'
    filter.parent().find('.one-click-open').click()

  onFilterModeChange: (evt) =>
    @$el.find('#query-filters-tabs li').removeClass('active')
    @$el.find('.filter-group').addClass('hidden')
    target = $(evt.currentTarget)
    target.addClass('active')
    @$el.find(".#{target.attr('id')}").removeClass('hidden')
    @dashboardSearchMethod = target.data('search-method')
    @trigger('searchMethodChange', @dashboardSearchMethod)

  onPostFilters: () =>
    @trigger('showPostFilterContents')
    @eventAggregator.trigger('showResultsView')

  onContentFilters: () =>
    @trigger('showContentFilterContents')

  disableContentsTab: () =>
    # Disable comment selection when post selection changed
    @$el.find('#content-filters').addClass('disabled')
